/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HistogramDTO
 */
export interface HistogramDTO {
    /**
     * 
     * @type {Array<number>}
     * @memberof HistogramDTO
     */
    edges?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof HistogramDTO
     */
    type?: HistogramDTOTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof HistogramDTO
     */
    values?: Array<number>;
}


/**
 * @export
 */
export const HistogramDTOTypeEnum = {
    Counting: 'COUNTING',
    Density: 'DENSITY'
} as const;
export type HistogramDTOTypeEnum = typeof HistogramDTOTypeEnum[keyof typeof HistogramDTOTypeEnum];


/**
 * Check if a given object implements the HistogramDTO interface.
 */
export function instanceOfHistogramDTO(value: object): value is HistogramDTO {
    return true;
}

export function HistogramDTOFromJSON(json: any): HistogramDTO {
    return HistogramDTOFromJSONTyped(json, false);
}

export function HistogramDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistogramDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'edges': json['edges'] == null ? undefined : json['edges'],
        'type': json['type'] == null ? undefined : json['type'],
        'values': json['values'] == null ? undefined : json['values'],
    };
}

export function HistogramDTOToJSON(value?: HistogramDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'edges': value['edges'],
        'type': value['type'],
        'values': value['values'],
    };
}

